export default __webpack_public_path__ + "static/media/welcomeToTheHalfHouse.c19e037e.png";